<template>
    <div class="fullscreen bg_project">
        <div class="logo"></div>
        <div class="menu" @click="showFullSwiper"></div>
        <header>
            <h1 class="title">
                <div class="title_img"></div>
            </h1>
            <p class="title--sub" v-if="timeGroup">数据统计时间：{{timeGroup[0]}}-{{timeGroup[1]}}</p>
        </header>
        
        <div class="main">
            <div class="main--up flex_justify_between mb_15">
                <div class="box_chart--doubleLine subscript right_bottom left_top project_box">
                    <div class="detailBox">
                        <div class="item">
                            <p class="label">开工面积(万㎡)</p>
                            <p v-if="startWorkDataTotal">
                                <span class="value c_area">{{startWorkDataTotal.Area}}</span>
                                <span class="ratio">环比 {{startWorkDataTotal.AreaRound}}%</span>
                                <i
                                    class="iconfont icon-iconfont_up"
                                    :class="{'icon-iconfont_down1':startWorkDataTotal.AreaRoundType=='2'}">
                                </i>
                            </p>
                        </div>
                        <div class="item">
                            <p class="label">开工套数(套)</p>
                            <p v-if="startWorkDataTotal">
                                <span class="value c_count">{{startWorkDataTotal.iCnt}}</span>
                                <span class="ratio">环比 {{startWorkDataTotal.PriceRound}}%</span>
                                <i
                                    class="iconfont icon-iconfont_up"
                                    :class="{'icon-iconfont_down1':startWorkDataTotal.PriceRoundType=='2'}">
                                </i>
                            </p>
                        </div>
                    </div>
                    <div class="chartsBox">
                        <Echarts v-if="startWorkData" :options="getOptions('base',startWorkData)"></Echarts>
                    </div>
                </div>
                <div class="box_cutAngle--allbg narrow subscript right_bottom">
                    <p class="box_cutAngle_title">开工项目类型占比</p>
                    <div class="box_cutAngle_splitline"></div>
                    <div class="flex_justify_between">
                        <div class="pieChartBox">
                            <Echarts v-if="startProject" :options="getOptions('pie',startProject)"></Echarts>
                        </div>
                    </div>
                </div>
                <div class="main--right">
                    <div class="box_cutAngle--bg subscript left_top" style="overflow: auto;" >
                        <p class="box_cutAngle_title c_pointer" @click="labelClick('company','100')">
                            <span class="strong">TOP100</span>房企本月开工项目
                        </p>
                        <div class="tableList land_transaction" >
                            <div class="item head">
                                <div class="cell">开发商</div>
                                <div class="cell">项目名称</div>
                                <div class="cell">建面(万㎡)</div>
                            </div>
                            <div class="tableList_main tableListHeight" v-if="companyTop100&&companyTop100.length">
                                <ScrollBox :num='companyTop100.length'>
                                    <ul slot="main">
                                        <li class="item c_pointer" v-for="(item,index) in companyTop100" :key="index" @click="toDetail(item.SolutionID)">
                                            <div class="cell">
                                                {{item.Company}}
                                            </div>
                                            <div class="cell" :title="item.Caption">{{item.Caption}}</div>
                                            <div class="cell">{{item.Area}}</div>
                                        </li>
                                    </ul>
                                </ScrollBox>
                            </div>
                            <!-- <ul class="tableList_main" v-if="companyTop100">
                                <li class="item" v-for="(item,index) in companyTop100" :key="index">
                                    <div class="cell">
                                        {{item.Company}}
                                    </div>
                                    <div class="cell">{{item.Caption}}</div>
                                    <div class="cell">{{item.Area}}</div>
                                </li>
                            </ul> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="main--down flex_justify_between">
                <div class="main--left">
                    <div class="box_cutAngle--bg subscript right_bottom left_top mb_15">
                        <p class="box_cutAngle_title">
                            本月房企开工建面<span class="strong">TOP10</span><span class="unit">({{companyAreaUnit}})</span>
                        </p>
                        <div class="box_cutAngle_splitline"></div>
                        <SwiperList
                            theme="green"
                            :hasInnerSplit="false"
                            :hasValue="true"
                            iconType="arrow"
                            iconPosition="before"
                            labelType="longLabel"
                            :perBaseData="companyAreaTT"
                            :showData="companyAreaTop10"
                            @labelClick="(name)=>labelClick('company',name)">
                        </SwiperList>
                        <!-- <ul class="progressbarList mt_5">
                            <li class="item" v-for="(item,index) in companyAreaTop10" :key="index">
                                <div class="label">{{item.name}}</div>
                                <div class="valueBar flex_align">
                                    <div class="innerBar green" :style="{'width':item.value/companyAreaTT * 100+'%'}"></div>
                                    {{item.value}}
                                </div>
                                <div class="value">
                                    <i class="iconfont" :class="{
                                        'icon-iconfont_up1':item.status=='up',
                                        'icon-iconfont_down':item.status=='down',
                                    }"></i>
                                    {{item.changeValue}}
                                </div>
                            </li>
                        </ul> -->
                    </div>
                    <div class="box_cutAngle--bg subscript right_bottom left_top">
                        <p class="box_cutAngle_title">
                            本月开工建面<span class="strong">TOP10</span>城市<span class="unit">({{cityAreaUnit}})</span>
                        </p>
                        <div class="box_cutAngle_splitline"></div>
                        <SwiperList
                            theme="blue"
                            :hasInnerSplit="true"
                            :hasValue="true"
                            iconType="arrow"
                            iconPosition="before"
                            :perBaseData="cityAreaTT"
                            :showData="cityAreaTop10"
                            @labelClick="(name)=>labelClick('city',name)">
                        </SwiperList>
                        <!-- <ul class="progressbarList mt_5">
                            <li class="item" v-for="(item,index) in cityAreaTop10" :key="index">
                                <div class="label">{{item.name}}</div>
                                <div class="valueBar flex_align">
                                    <div class="innerBar blue" :style="{'width':item.value/cityAreaTT+'%'}">
                                        <div class="innerSplit"></div>
                                    </div>
                                    {{item.value}}
                                </div>
                                <div class="value">
                                    <i class="iconfont" :class="{
                                        'icon-iconfont_up1':item.status=='up',
                                        'icon-iconfont_down':item.status=='down',
                                    }"></i>
                                    {{item.changeValue}}
                                </div>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <div class="main--middle">
                    <div class="box_map">
                        <div class="mapTitle flex_center">全国开工项目分布图</div>
                        <!-- 地图 -->
                        <div class="map-main" ref="zfyxMap"></div>
                        <!-- 地图柱状缩略图 -->
                        <div class="map-chart">
                            <Echarts ref="mapBar" v-if="mapBarData" :options="getOptions('mapBar',mapBarData)" @chartClick="mapBarClick($event)"></Echarts>
                        </div>

                    </div>
                </div>
                <div class="main--right">
                    <div class="box_cutAngle--bg tab_cutAngle_box subscript right_bottom left_top">
                        <ul class="tab_cutAngle flex_justify_between pt_15">
                            <li
                                class="item"
                                :class="{'active':activeTab==index}"
                                v-for="(item,index) in newsTab"
                                :key="index"
                                @click="switchTab(index)">
                                {{item.label}}
                            </li>
                        </ul>
                        <div class="tableList project_tabtable firstTab" v-if="activeTab == 0" :class="{'tab_right':activeTab==1}">
                            <div class="item head">
                                <div class="cell">项目名称</div>
                                <div class="cell">开发商</div>
                                <div class="cell">开工时间</div>
                            </div>
                            <div class="tableList_main tableListHeight2" v-if="newProject.startPro&&newProject.startPro.length">
                                <ScrollBox :num='newProject.startPro.length'>
                                    <ul slot="main">
                                        <li class="item c_pointer" v-for="(item,index) in newProject.startPro" :key="index" @click="toDetail(item.SolutionID)">
                                            <div class="cell" :title="item.Caption">{{item.Caption}}</div>
                                            <div class="cell">{{item.VIPShortName}}</div>
                                            <div class="cell">{{item.BuildTime}}</div>
                                        </li>
                                    </ul>
                                </ScrollBox>
                            </div>
                            <!-- <ul class="tableList_main">
                                <li class="item" v-for="(item,index) in newProject.startPro" :key="index">
                                    <div class="cell">{{item.Caption}}</div>
                                    <div class="cell">{{item.VIPShortName}}</div>
                                    <div class="cell">{{item.BuildTime}}</div>
                                </li>
                            </ul> -->
                        </div>

                        <div class="tableList project_tabtable"  v-if="activeTab == 1" :class="{'tab_right':activeTab==1}">
                            <div class="item head">
                                <div class="cell">开发商</div>
                                <div class="cell">行业</div>
                                <div class="cell">招标名称</div>
                            </div>
                            <div class="tableList_main tableListHeight2" v-if="newProject.bidPro&&newProject.bidPro.length">
                                <ScrollBox :num='newProject.bidPro.length'>
                                    <ul slot="main">
                                        <li class="item c_pointer" v-for="(item,index) in newProject.bidPro" :key="index" @click="toDetail2(item.HomeId,item.BidId)">
                                            <div class="cell">{{item.ShortName}}</div>
                                            <div class="cell">{{item.IndustryName}}</div>
                                            <div class="cell">{{item.BidTitle}}</div>
                                        </li>
                                    </ul>
                                </ScrollBox>
                            </div>
                            <!-- <ul class="tableList_main">
                                <li class="item" v-for="(item,index) in newProject.bidPro" :key="index">
                                    <div class="cell">{{item.ShortName}}</div>
                                    <div class="cell">{{item.IndustryName}}</div>
                                    <div class="cell">{{item.BidTitle}}</div>
                                </li>
                            </ul> -->
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        
    </div>
</template>
<script>
import Echarts from "@/components/Echarts";
import getCharts from "@/utils/getCharts.js";
import mapMin from "@/mixins/map.js";
import api from "@/server/api.js";
import echarts from 'echarts/lib/echarts'
import Util from '@/utils/Util';
import permission from "@/mixins/permission.js";
window.__Echarts = echarts
// const dpr = window.devicePixelRatio;
const dpr = Util.setDpr();
export default {
    mixins:[mapMin,permission],
    data(){
        return {
            //开工数据
            startWorkData:null,
            startWorkDataTotal:null,

            //开工项目类型占比
            startProject:null,
            //company top100
            companyTop100:null,
            //房企开工建面
            companyAreaTop10:null,
            companyAreaTT:0,
            companyAreaUnit:'',
            //城市开工建面
            cityAreaTop10:null,
            cityAreaTT:0,
            cityAreaUnit:'',
            //最新开工项目和招标项目
            newProject:{
                startPro:[],
                bidPro:[]
            },

            mapBarData:null,

            newsTab:[
                {value:0,label:'最新开工项目'},
                {value:1,label:'最新项目招标'},
            ],
            activeTab:0,
            //统计时间段
            timeGroup:null,
        }
    },
    components: {
        Echarts,
    },
    created() {
      this.initData();
      document.title="房企项目开工监控系统 - 优采大数据"
    },
    beforeDestroy() {
        clearInterval(this.MapTimmer);
    },
    methods: {
        showFullSwiper(){
            this.$emit('showFullSwiper');
        },
        switchTab(index){
            this.activeTab=index
        },
        getOptions(echartType,obj) {
            switch (echartType) {
                case 'pie':
                    let pieoption = getCharts.getPieEchart(obj);
                    return pieoption;
                    break;
                case 'base':
                    let baseoption = getCharts.getBaseEchart(obj);
                    return baseoption;
                    break;
                case 'ladderBar':
                    let ladderbaroption = getCharts.getLadderBarEchart(obj);
                    return ladderbaroption;
                    break;
                case 'mapBar':
                    let mapBarOption = getCharts.getMapBarEchart(obj,this.mapBarDataMax);
                    return mapBarOption;
                    break;
                default:
                    break;
            }
        },
        /** 地图缩略图表增加click事件 */
        mapBarClick(params){
            let _city = this.mapBarData.filter(e => {
                return e.name == params.name ;
            })[0];

            let _arr = [] ;
            if(_city && _city.aList){
                _city.aList.forEach(e => {
                    if(!!e.X ){
                        _arr.push({
                            name:e.Caption,
                            invisor:e.Invisor,
                            coversArea:e.TotalBuildArea+'㎡',
                            salesPrice:e.FitmentPrice_Max + '万元',
                            center:[Number(e.X),Number(e.Y)],
                            PlanCounts:e.PlanCounts,
                            SolutionID:e.SolutionID,
                            X:Number(e.X),
                            Y:Number(e.Y)
                        });
                    }
                })
            }
            this.drawPolygonAndRichMark(_arr);
        },
        drawPolygonAndRichMark(_array){

            this.$nextTick(() => {
                this.map.clearOverlays();
                let _Marks = [] ;
                _array.forEach(elem => {
                    if(!!elem.X ){
                        // X和Y可能是字符串或逗号分隔的字符串
                        let x, y;
                        if (typeof elem.X === 'string' && elem.X.includes(',')) {
                            // 逗号分隔的字符串，取第一个坐标
                            let xCoords = elem.X.split(',').filter(c => c.trim());
                            let yCoords = elem.Y.split(',').filter(c => c.trim());
                            x = xCoords.length > 0 ? parseFloat(xCoords[0]) : null;
                            y = yCoords.length > 0 ? parseFloat(yCoords[0]) : null;
                        } else {
                            // 单个数值
                            x = parseFloat(elem.X);
                            y = parseFloat(elem.Y);
                        }

                        if (x && y && !isNaN(x) && !isNaN(y)) {
                            let point = new BMapGL.Point(x, y);
                            let el = this.drawRichMark(point, this.getMarkHtml() , [0,0],this.map,{'click':(e)=>{
                                this.clickPolygon(elem);
                            }});
                            _Marks.push(elem);
                        }
                    }
                });

                let _index = 0 ;

                clearInterval(this.MapTimmer);
                if(_array.length > 0){
                    this.resetRichMark(_array[0]);
                    _index ++ ;
                    this.MapTimmer = setInterval( () => {
                        if(_index == _array.length ){
                            _index  =  0 
                        }
                        if(_array.length != 0){
                            this.resetRichMark(_array[_index]);
                        }else {
                            clearInterval(this.MapTimmer );
                        }
                        _index ++ ;
                    },5000);
                }
            })
          
        },
        resetRichMark(elem){
            if(!elem.X){
                return false;
            }
            this.RichMark && this.map.removeOverlay(this.RichMark) ;
            // X和Y可能是字符串或逗号分隔的字符串
            let x, y;
            if (typeof elem.X === 'string' && elem.X.includes(',')) {
                // 逗号分隔的字符串，取第一个坐标
                let xCoords = elem.X.split(',').filter(c => c.trim());
                let yCoords = elem.Y.split(',').filter(c => c.trim());
                x = xCoords.length > 0 ? parseFloat(xCoords[0]) : null;
                y = yCoords.length > 0 ? parseFloat(yCoords[0]) : null;
            } else {
                // 单个数值
                x = parseFloat(elem.X);
                y = parseFloat(elem.Y);
            }

            if (x && y && !isNaN(x) && !isNaN(y)) {
                let point = new BMapGL.Point(x, y);
                this.RichMark = this.drawRichMark(point, this.getOverlayHtml(elem) , [0,0],this.map,{'click':(e)=>{
                    // console.log(elem)
                    this.toDetail(elem.SolutionID)
                }});
                this.map.panTo(point);
            }
        },
        clickPolygon(elem){
            clearInterval(this.MapTimmer);
            this.resetRichMark(elem);
        },
        getMarkHtml(){
            return `<div></div>`
        },
        getOverlayHtml(currentMapInfo){
            // <div class="od-title">${currentMapInfo.name}</div>
            return `<div class="overlay--details green">
                        <div class="od-info">
                            <div class="items">
                                <div class="label">项目名称：</div>
                                <div class="value" title="${currentMapInfo.name}">${currentMapInfo.name}</div>
                            </div>
                            <div class="items">
                                <div class="label">项目开发商：</div>
                                <div class="value" title="${currentMapInfo.invisor}">${currentMapInfo.invisor}</div>
                            </div>
                            <div class="items">
                                <div class="label">总建面积：</div>
                                <div class="value">${currentMapInfo.coversArea}</div>
                            </div>
                            <div class="items">
                                <div class="label">规划户数：</div>
                                <div class="value">${currentMapInfo.PlanCounts}</div>
                            </div>
                        </div>
                        <div class="od-point"></div>
                        <div class="line-45">
                            <div class="ins"></div>
                        </div>
                    </div>`
        },
        initData(){
            //时间
            api.getHomeDate().then(res => {
                if(!res.ErrorCode){
                    this.timeGroup = res.Data;
                }
            })
            //项目开工统计
            api.homeWorkCount().then(res => {
                // console.log('折线图',res)
                if(!res.ErrorCode){
                    this.startWorkDataTotal = res.Data.aHomeCount[0];
                     //开工面积、开工套数(折线图)
                    this.startWorkData = {
                            unit:['万㎡','套'],
                            color:['#F39800','#02CCFF'],
                            yAxisNum:2,
                            grid: {
                                left: '5%',
                                right: '3%',
                            },
                            xAxis:{
                                data: res.Data.aHomeChart.map(e => {
                                    return e.sTime
                                })
                            },
                            yAxis:{
                                splitLine: {
                                    show: true,
                                    lineStyle:{
                                        color: '#C5D0DE',
                                        opacity:0.3,
                                        width: 1*dpr,
                                    }
                                },
                            },
                            series:[
                                {
                                    name: '开工面积',
                                    type: 'line',
                                    symbolSize:0,
                                    lineStyle: {
                                        width:2*dpr,
                                        color:'#F39800'
                                    },
                                    areaStyle: { //区域填充样式
                                        normal: {
                                            //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                                            color: new __Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                { offset: 0,  color: 'rgba(243, 152, 0, 0.5)'}, 
                                                { offset: 1,  color: 'rgba(243, 152, 0, 0)'}
                                            ], false),
                        
                                        }
                                    },
                                    data: res.Data.aHomeChart.map(e => {
                                        return Number(e.Area)
                                    })
                                },
                                {
                                    name: '开工套数',
                                    type: 'line',
                                    symbolSize:0,
                                    yAxisIndex:1,
                                    lineStyle: {
                                        width:2*dpr,
                                        color:'#02CCFF'
                                    },
                                    areaStyle: { //区域填充样式
                                        normal: {
                                            //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                                            color: new __Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                { offset: 0,  color: 'rgba(2, 204, 255, 0.5)'}, 
                                                { offset: 1,  color: 'rgba(2, 204, 255, 0)'}
                                            ], false),
                                        },
                                    },
                                    data:  res.Data.aHomeChart.map(e => {
                                        return Number(e.iCnt)
                                    })
                                },
                            ]
                        }
                }
            })
            //开工项目类型占比
            api.homeTypePro().then(res => {
                // console.log('开工项目类型占比',res)
                if(!res.ErrorCode){
                    this.startProject = {
                        series:{
                            name:'开工项目类型占比',
                            data: res.Data.map( e=> {
                                return {
                                    name:e.type,
                                    value:Number(e.iCnt),
                                    pro: Number(e.Pro)
                                }
                            }),
                            startAngle: -65,
                            // minAngle: 15,
                            // center: ['50%', '50%'],
                        },
                        tooltip:{
                            formatter: function(param) {
                                // console.log(param)
                                let title = `<span class="fs_12 c_fff">${param.name}</span>`
                                let percent = `<span class="fs_12 c_fff">
                                                    占比
                                                    <span class="fs_16 fw_b">${param.percent}</span>%
                                                </span>`
                                let value = `<span class="fs_12 c_fff">
                                                    拿地
                                                    <span class="fs_16 fw_b">${param.value}</span>幅
                                                </span>`
                                
                                return param.marker + title + '<br />' + percent + '<br />' + value
                                    
                            },
                        }
                    }
                }
            })
            // 房企开工建面
            api.companyHomeArea().then(res => {
                // console.log('房企开工建面',res)
                if(!res.ErrorCode){
                    this.companyAreaTop10 = res.Data.aTakeHomeData;
                    this.companyAreaTT = res.Data.aAllArea ;
                    this.companyAreaUnit = res.Data.sUnit ;
                }
            })
            //城市开工建面
            api.cityHomeArea().then(res => {
                // console.log('城市开工建面',res)
                if(!res.ErrorCode){
                    this.cityAreaTop10 = res.Data.aHomeData;
                    this.cityAreaTT = res.Data.aAllArea ;
                    this.cityAreaUnit = res.Data.sUnit ;
                }
                
            })
            //开工项目分布图地图
            api.getHomeData().then(res => {
                console.log('开工项目分布图地图',res)
                if(!res.ErrorCode){
                    this.mapBarData = res.Data.map( e => {
                        return {
                            name: e.CityCaption,
                            value: e.count,
                            aList: e.aList
                        }
                     });

                     this.mapBarDataMax = Math.max(...res.Data.map(e => {
                         return e.count 
                     }));

                     this.landList = [] ;

                     this.mapBarData.forEach(el => {
                         el.aList.forEach(e => {
                             if(!!e.X ){
                                this.landList.push({
                                    name:e.Caption,
                                    invisor:e.Invisor,
                                    coversArea:e.TotalBuildArea+'㎡',
                                    salesPrice:e.FitmentPrice_Max + '万元',
                                    PlanCounts:e.PlanCounts,
                                    SolutionID:e.SolutionID,
                                    center:[Number(e.X),Number(e.Y)],
                                    X:Number(e.X),
                                    Y:Number(e.Y)
                                });
                             }
                         })
                     })

                    this.$nextTick( () => {
                        this.drawPolygonAndRichMark(this.landList);
                    })
                }
            })
            //房企开工项目 top100
            api.companyHomeStart().then(res => {
                // console.log('房企开工项目',res)
                if(!res.ErrorCode){
                    this.companyTop100 = res.Data ;
                }
            })
            //最新开工项目
            api.latestStartHome().then(res => {
                // console.log('最新开工项目',res)
                if(!res.ErrorCode){
                    this.newProject.startPro = res.Data.map(e => {
                        return {
                            Area: e.Area,
                            BuildTime:e.BuildTime,
                            Caption:e.Caption,
                            VIPShortName: e.VIPShortName,
                            SolutionID: e.SolutionID
                        }
                    });
                }
            })
            //最新项目招标
            api.latestTenderHome().then(res => {
                console.log('最新项目招标',res)
                if(!res.ErrorCode){
                   this.newProject.bidPro= res.Data.map(e => {
                        return {
                            BidTitle: e.BidTitle,
                            IndustryName: e.IndustryName,
                            ShortName:e.ShortName,
                            HomeId:e.HomeId,
                            BidId:e.BidId,
                        }
                    });
                }
            })
        },
        // topList 点击跳转=>列表
        labelClick(type,name=''){
            // console.log('labelClick',this.timeGroup)
            let reg = /[^\d]+/g;
            let _dataRange = this.timeGroup.map(e=>{
                return e.replace(reg, "-").substring(0,e.length-1);
            })
            let routeData = this.$router.resolve({
                path: '/page/project',
                query:{
                    startDate:_dataRange[0],
                    endDate:_dataRange[1],
                    type:type,
                    name:name
                }
            });
	        window.open(routeData.href, this.isScreen?'_self':'_blank');
        },
        // 详情跳转=>项目
        toDetail(id){
            if(this.userType==1){
                this.showTip();
                return
            }
            let routeData = this.$router.resolve({
                path: '/page/detail',
                query:{
                    module:2,  
                    type:2,  
                    id:id,  
                }
            });
	        window.open(routeData.href, this.isScreen?'_self':'_blank');
            // this.$router.push({
            //     path: '/page/detail',
            //     query:{
            //         module:2,
            //         type:2,
            //         id:id,
            //     }
            // })
        },
        // 详情跳转=>招标
        toDetail2(id,bId){
            console.log(id,bId)
            let routeData = this.$router.resolve({
                path: '/page/detail',
                query:{
                    module:4,  
                    type:3,  
                    id:id, 
                    bId:bId 
                }
            });
	        window.open(routeData.href, this.isScreen?'_self':'_blank');
            // this.$router.push({
            //     path: '/page/detail',
            //     query:{
            //         module:4,
            //         type:3,
            //         id:id,
            //         bId:bId
            //     }
            // })
        },

    },
}
</script>
<style lang="scss" scoped>
@use '../../assets/styles/mixin' as *;
.logo{ background-image: url('../../assets/imgs/logo_project.png');}
.menu{opacity: .6;}
header{
    height: 10vh;
    box-sizing: border-box;
    padding-top: 2.4vh;
    text-align: center;
    .title{
        // font-size:.44rem;
        // font-weight: bold;
        // @include text_gradient(top,#FFFFFF,#50B8D1);
        .title_img{
            display: inline-block;
            width: 4.69rem;
            height: .63rem;
            background: url('../../assets/imgs/project_title.png') center center no-repeat;
            background-size: cover;
        }
    }
    .title--sub{
        font-size:.18rem;
        color: #fff;
        line-height: 2;
        display: inline-block;
        padding: 0 .1rem;
        margin-top: -0.5vh;
        border: .02rem solid rgba($color: #02ccff, $alpha: 0.4);
        background-color: rgba($color: #010b10, $alpha: 0.2);
    }
}

.main--up{
    .box_chart--doubleLine{
        width: 50.4vw;
        height: 100%;
    }
    .main--right{
        height: 100%;
        .box_cutAngle--bg{
            height: 100%;
        }
    }
    .box_cutAngle_pie{
        width: 17.5vw;
        height: 100%;
    }
    .pieChartBox{
        width: 100%;
    }
}

.project_box{
    border: .02rem solid rgba($color: #02ccff, $alpha: 0.4);
    background-color: rgba($color: #010b10, $alpha: 0.2);
}

.box_cutAngle--bg{
    border-left: .02rem solid rgba($color: #02ccff, $alpha: 0.4);
    background-image: url('../../assets/imgs/project_angle_bg01.png'),url('../../assets/imgs/project_angle_bg02.png');
}

.tab_cutAngle_box{
    width: 100%;
    height: 54.4vh;
    background-image: url('../../assets/imgs/project_angle_bg03.png'),url('../../assets/imgs/project_angle_bg04.png');
}

.box_chart--doubleLine{
    .detailBox{
        .item{
            .value{
                font-size: .48rem;
                line-height: 1.5;
            }
        }
    }
}


.box_map{
    border-color: rgba($color: #02ccff, $alpha: 0.4);
    background-color: rgba($color: #010b10, $alpha: 0.2);
    padding: 0 .03rem;
}

.mapTitle{
    width: 2.77rem;
    height: .64rem;
    font-size: .24rem;
    font-weight: bold;
    color: white;
    background: url('../../assets/imgs/project_mapTitle.png') 0 0 no-repeat;
    background-size: 100%;
    position: absolute;
    left: .1rem;
    top: .1rem;
    z-index: 10;
}

.map-main {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.map-chart {
    position: absolute;
    width: 30%;
    height: 41%;
    background:#000;
    border:2px solid rgba(6, 104, 186, 0.5);
    bottom: 0.1rem;
    right: 0.1rem;
    z-index: 10;
    pointer-events: auto;
}

.tableListHeight{
    height: 18vh;
}
.tableListHeight2{
    height: 43vh;
}

</style>
